const contactForm = document.querySelector('#ContactForm');

if (contactForm) {
  const contactFormEmail = document.querySelector('#ContactForm-email');
  const errorMessage = document.querySelector('#ContactForm-email-error-message');

  function validateEmail() {
    const email = contactFormEmail.value;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (emailRegex.test(email)) {
      contactFormEmail.setAttribute('aria-invalid', 'false');
      contactFormEmail.setAttribute('aria-describedby', '');
      errorMessage.style.display = 'none';
      return true;
    } else {
      contactFormEmail.setAttribute('aria-invalid', 'true');
      contactFormEmail.setAttribute('aria-describedby', 'ContactForm-email-error-message');
      errorMessage.style.display = 'block';
      return false;
    }
  }

  let timeout;
  contactFormEmail.addEventListener('input', () => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      validateEmail();
    }, 500);
  });

  contactForm.addEventListener('submit', (e) => {
    const isEmailValid = validateEmail();

    if (!isEmailValid) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  });
}
